<div
    *ngIf="(toastService.getMessage() | async) as message"
    class="notification"
    [ngClass]="{
        'is-danger': (message.type === 'error'),
        'is-warning': (message.type === 'warning'),
        'is-success': (message.type === 'success'),
        'is-info': ((message.type === 'info') || (!message.type))
    }"
>
    <button class="delete" (click)="toastService.closeMessage()"></button>
    <span [innerHTML]="message.text"></span>
</div>



// WEBPACK FOOTER //
// ./src/layout/toast/toast.component.html